module.exports = __webpack_public_path__ + "img/logo_rabby.ee4cda5d.png";